import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('estimation', 'estimations');

const customActions = {
  async LOAD_estimations({ commit, rootGetters }) {
    console.debug('load estimation');
    const data = await odata.o(rootGetters)
      .get('estimations')
      .query({
        $filter: 'IsDeleted eq false',
        $expand: 'Brand,Client',
      });
    commit('SET_estimations', data);

    return data;
  },
};

export default { ...actions, ...customActions };
